import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Heading from "../components/individuals/Heading";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import FadeInSection from "../components/wrappers/FadeInSection";
import { FadeInType } from "../components/wrappers/FadeInSection";

const People = [
  {
    name: "Justin Yon",
    title: "Chapter Leader",
    description:
      "Student at Mainland Regional High School. Student Council president, eCybermission NJ 1st Place, and Published Medical Researcher",
    image: "/assets/leaders/justin.jpg",
  },
  {
    name: "Nathaniel Kashey",
    title: "Chapter Leader",
    description:
      "Student at Mainland Regional High School. Published AI Researcher, 1st Team All-South Jersey for Football, and National Honor Society inductee.",
    image: "/assets/leaders/nate.jpeg",
  },
  {
    name: "Arindom Paul",
    title: "Chapter Leader",
    description:
      "Student at Mainland Regional High School. Chess Club co-founder, All South Jersey Band 1st chair Orchestra, and FTC team 7149 3D printing lead.",
    image: "/assets/leaders/arindom.jpg",
  },
  {
    name: "Radhika Patel",
    title: "Chapter Leader",
    description:
      "Student at Nutley High School. Varsity Golfer, Robotics Captain, Percussionist at various locations, and Board Member of NNDYM.",
    image: "/assets/leaders/radhika.jpg",
  },
];

const FAQs = [
  {
    question: "What is STEM?",
    answer:
      "STEM stands for the fields of Science, Technology, Engineering, and Mathematics.",
  },
  {
    question: "How do I get involved as a student?",
    answer:
      "Join our newsletter and follow our social media for information on our future events and any other opportunities. We also plan to offer leadership opportunities to students, so please stay posted.",
  },
  {
    question:
      "How do I get involved as a parent, educator, or community member?",
    answer:
      "Join our newsletter and follow our social media for information on our future events and any other opportunities. If you have any specific ideas or suggestions, please reach out to us!",
  },
  {
    question: "What is a partner?",
    answer:
      "A partner is any organization or business which supports our mission and works with our organization to inspire STEM literacy and excitement across Pennsylvania. Visit our partners' page for more information.",
  },
  {
    question: "How do I get involved as a partner?",
    answer:
      "Don't hesitate to contact us if you want to become a partner, as we are always happy to talk.",
  },
  {
    question: "Are there any volunteering opportunities for high schoolers?",
    answer:
      "You can volunteer by creating your own chapter, or ask any nearby chapters about any specific opportunities. ",
  },
  {
    question: "Any other questions?",
    answer:
      "Visit our contact us page or email us, and we'll get back to you as soon as possible.",
  },
];

const partners = [
  { name: "Bucks County Library", src: "./assets/partners/bclibrary.jpg" },
  { name: "Stemist Hacks", src: "./assets/partners/stemist.png" },
  { name: "Devpost", src: "./assets/partners/devpost.svg" },
  { name: "Echo 3D", src: "./assets/partners/echo3D.png" },
  { name: "Sticker Giant", src: "./assets/partners/stickergiant.png" },
  { name: "FAB LAB", src: "./assets/partners/fablab.png" },
  {
    name: "Council Rock School District",
    src: "./assets/partners/crschools.jpeg",
  },
];

export default function About() {
  return (
    <div className="w-full h-full">
      <Navbar />
      <section className="pt-[120px] relative z-40">
        <FadeInSection distance={FadeInType.FADEONLY}>
          <Heading
            heading="Inspiring Tommorow's Innovators"
            className="text-center text-primary mt-10"
          />
        </FadeInSection>
        <FadeInSection distance={FadeInType.SHORT}>
          <div className="mt-6 lg:max-w-4xl text-xl mx-auto max-w-5/6">
            <div className="space-y-6 max-w-5xl mx-auto border-black/10 border-1 dark:bg-white/10 bg-gray-50 dark:text-white/60 text-gray-900 p-8 rounded-xl shadow-lg">
              <p className="text-xl font-medium leading-relaxed border-l-4 pl-4 border-l-primary dark:text-white/90">
                We are a student-led organization dedicated to transforming STEM
                education across New Jersey—starting at the foundation.
              </p>
              <p className="leading-relaxed">
                At STEM Enrichment of New Jersey, we believe that scientific
                curiosity begins in childhood at elementary-age learners, long
                before students ever step into a high school lab.
              </p>
              <p className="leading-relaxed">
                Our mission is not about stacking resumes or checking boxes for
                college applications—it’s about something far greater: authentic
                passion and real impact.
              </p>
              <p className="leading-relaxed">
                Through hands-on workshops and coding challenges, we spark
                curiosity and problem-solving in young minds.
              </p>
              <p className="font-medium text-primary text-lg leading-relaxed italic">
                — Benjamin Wang &amp; Krish Patel{" "}
              </p>
            </div>
          </div>
        </FadeInSection>
        <div className="px-4 mx-auto w-5/6 xl:w-3/5 mt-10">
          <FadeInSection distance={FadeInType.SHORT}>
          <div className="relative mx-auto mb-12 pt-6 text-center md:mb-20 lg:pt-16">
            <Heading
              heading="Meet our Leadership Team"
              className="text-center text-primary mt-10"
            />
            <p className="text-dark-text mx-auto max-w-[620px] text-base">
              By students, for students. Passionate innovators driving change in
              STEM education.
            </p>
          </div>
          </FadeInSection>
          <FadeInSection distance={FadeInType.SHORT}>
            <Splide
              options={{
                type: "loop",
                perPage: 1,
                autoplay: true,
                interval: 3000,
                pauseOnHover: true,
                arrows: true,
                pagination: false,
              }}
              hasTrack={false}
            >
              <div className="w-full px-4 border-2 border-primary/10 dark:border-white/10 bg-white dark:bg-white/5 rounded-lg shadow-lg">
                <div className="relative z-10 overflow-hidden rounded-sm bg-cover bg-center px-10 pt-[60px] pb-5 sm:px-14 md:pb-5 md:p-[70px] lg:pb-[70px]">
                  <SplideTrack>
                    {People.map((person, index) => (
                      <SplideSlide key={index}>
                        <div className="-mx-4 flex flex-wrap items-center">
                          <div className="order-last w-full px-4 lg:order-first lg:w-1/2">
                            <div className="text-center lg:text-left">
                              <p className="font-main text-dark-text mb-9 text-base font-light lg:text-lg xl:text-[19px] 2xl:text-2xl">
                                {person.description}
                              </p>

                              <h3 className="font-main text-dark mb-1 text-xl dark:text-white">
                                {person.name}
                              </h3>
                              <p className="text-dark-text text-base">
                                {person.title}
                              </p>
                            </div>
                          </div>
                          <div className="w-full px-4 lg:w-1/2">
                            <div className="relative mx-auto mb-9 h-full w-full lg:mr-0 lg:mb-0 aspect-square p-7">
                              <div className="max-w-full h-full ">
                                <img
                                  src={person.image}
                                  alt="person-profile"
                                  className="object-cover w-full h-full"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </SplideSlide>
                    ))}
                  </SplideTrack>
                </div>
                <div className="flex lg:absolute bottom-14 splide__arrows px-10 sm:px-14 md:px-[70px] items-center justify-center pb-5 lg:pb-0 z-100">
                  <button
                    type="button"
                    data-controls="prev"
                    className="splide__arrow splide__arrow--prev !flex !h-10 !w-10 !justify-center !items-center !rounded-full dark:!bg-white/10 !bg-primary/10 !text-primary dark:!text-white lg:!mr-5 !cursor-pointer hover:!bg-primary hover:!text-white !relative !opacity-100 !transform-none !left-0"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      className="!fill-current !transform-none !h-[20px] !w-[20px]"
                    >
                      <path d="M6.52329 10.8331L10.9933 15.3031L9.81496 16.4814L3.3333 9.99978L9.81496 3.51811L10.9933 4.69645L6.52329 9.16645L16.6666 9.16645L16.6666 10.8331L6.52329 10.8331Z"></path>
                    </svg>
                  </button>
                  <div className="min-w-3 lg:hidden"></div>
                  <button
                    type="button"
                    data-controls="next"
                    className="splide__arrow splide__arrow--next !flex !h-10 !w-10 !justify-center !items-center !rounded-full dark:!bg-white/10 !bg-primary/10 !text-primary dark:!text-white lg:!mr-5 !cursor-pointer hover:!bg-primary hover:!text-white !relative !opacity-100 !transform-none !right-0"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      className="!fill-current !transform-none !h-[20px] !w-[20px]"
                    >
                      <path d="M13.4767 9.16689L9.00671 4.69689L10.185 3.51855L16.6667 10.0002L10.185 16.4819L9.00671 15.3036L13.4767 10.8336H3.33337V9.16689H13.4767Z"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </Splide>
          </FadeInSection>
        </div>
        <div className="px-4 mx-auto w-5/6 xl:w-3/5 mt-10">
          <FadeInSection distance={FadeInType.SHORT}>
            <div className="relative mx-auto mb-12 pt-6 text-center md:mb-20 lg:pt-16">
              <Heading
                heading="Our Partners"
                className="text-center text-primary mt-10"
              />
            </div>
          </FadeInSection>
          <FadeInSection distance={FadeInType.SHORT}>
            <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-4">
              {partners.map((partner, idx) => (
                <div key={idx} className="flex flex-col items-center">
                  <div className="dark:bg-white/20 bg-gray-50 shadow-lg rounded-lg p-4 w-full flex items-center justify-center h-28">
                    <img
                      className="h-12 object-contain max-w-[80%]"
                      src={partner.src}
                      alt={partner.name}
                    />
                  </div>
                  <div className="mt-2 text-center text-sm font-medium dark:text-white/80 text-gray-900">
                    {partner.name}
                  </div>
                </div>
              ))}
            </div>
          </FadeInSection>
        </div>
        <div className="px-4 mx-auto w-5/6 xl:w-3/5 mt-10">
          <FadeInSection distance={FadeInType.SHORT}>
            <div className="relative mx-auto mb-12 pt-6 text-center md:mb-20 lg:pt-16">
              <Heading
                heading="Frequently Asked Questions"
                className="text-center text-primary mt-10"
              />
            </div>
          </FadeInSection>
          {FAQs.map((faq, index) => (
            <FadeInSection key={index} distance={FadeInType.SHORT}>
              <div className="mb-10 space-y-6 max-w-5xl mx-auto border-black/10 border-1 dark:bg-white/10 bg-gray-50 dark:text-white/60 text-gray-900 p-8 rounded-xl shadow-lg">
                <p className="text-xl font-medium leading-relaxed dark:text-white/90 inline-block mr-3">
                  {faq.question}
                </p>
                <span class="h-1 w-12 bg-primary rounded-full inline-block m-1"></span>
                <p className="leading-relaxed border-l-4 pl-4 border-l-primary mr-4">
                  {faq.answer}
                </p>
              </div>
            </FadeInSection>
          ))}
        </div>
        <div className="absolute top-0 right-0 -z-10">
          <svg
            width="1200"
            height="900"
            viewBox="0 0 1100 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter1)">
              <rect
                x="300"
                y="-3.65"
                width="629.62"
                height="757"
                transform="rotate(-40.44 463.78 -125.739)"
                fill="url(#grad1)"
              ></rect>
            </g>
            <defs>
              <filter
                id="filter1"
                x="0.0878906"
                y="-776.711"
                width="1726.24"
                height="1876.4"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad1"
                x1="420.6"
                y1="60.5"
                x2="960.732"
                y2="623.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.912" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="absolute bottom-0 left-0 -z-10">
          <svg
            width="1460"
            height="500"
            viewBox="0 0 1460 500"
            fill="none"
            className="overflow-visible"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.3" filter="url(#filter2)">
              <rect y="460" width="1020" height="250" fill="url(#grad2)"></rect>
            </g>
            <defs>
              <filter
                id="filter2"
                x="-440"
                y="10"
                width="2000"
                height="1050"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImage"></feFlood>
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImage"
                  result="shape"
                ></feBlend>
                <feGaussianBlur stdDeviation="225"></feGaussianBlur>
              </filter>
              <linearGradient
                id="grad2"
                x1="-94.8"
                y1="510.634"
                x2="-63.3028465"
                y2="810.234"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ABBCFF"></stop>
                <stop offset="0.8453" stopColor="#4A6CF7"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
      <Footer />
    </div>
  );
}
